module.exports = "<video>\n    <source type=\"video/mp4\" />\n</video>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/common/preroll/preroll.html
 ** module id = 243
 ** module chunks = 0
 **/